<template>
  <div v-if="lotPurchasedModal.lot && lotPurchasedModal.lot.currency" class="ta-bid-created-modal-data ta-bid-created-modal-your-bid">
    <div class="ta-data-label">
      {{ $t('Price')}}
    </div>
    <div class="ta-data-value">
      {{lotPurchasedModal.bid.amount | asCurrency(lotPurchasedModal.lot.currency.code)}}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "YourBid",
  computed: {
    ...mapState(['lotPurchasedModal']),
  }
}
</script>

<style lang="scss" scoped>
</style>
